export default {
  mounted(el, binding) {
    const distance = binding.value?.distance ?? 100
    const duration = binding.value?.duration ?? 1000

    // 初始状态：在视口外 → 不显示，从下方准备进入
    el.style.opacity = '0'
    el.style.transform = `translateY(${distance}px)`
    el.style.transition = `opacity ${duration}ms ease-out, transform ${duration}ms ease-out`

    const observer = new IntersectionObserver(
      ([entry]) => {
        // ✅ 只处理「第一次进入可视区域」
        if (entry.isIntersecting && !el.__revealed__) {
          el.__revealed__ = true

          // 自下而上缓动显示
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'

          // ⭐ 动画完成后，彻底停止观察
          observer.unobserve(el)
        }
      },
      {
        threshold: 0.1
      }
    )

    observer.observe(el)
    el.__revealObserver__ = observer
  },

  unmounted(el) {
    el.__revealObserver__?.disconnect()
  }
}
